import produce from 'immer'
import { ToppagesjoinusAction, ToppagesjoinusActionTypes } from '../actions/toppagesjoinusActions'
import { ApiStatus, IToppagesjoinusItem } from '../models'

export const initialToppagesjoinusState: IToppagesjoinusState = {
  loadingStatus: ApiStatus.NOTLOADED,
  addingStatus: ApiStatus.NOTLOADED,
  searchingStatus: ApiStatus.NOTLOADED,
  searchString: '',
  toppagesjoinus: [],
  foundtoppagesjoinus: [],
  totalDocs: 0,
  errMessage: '',
  errStatus: null,
  errField: null,
}

export default function toppagesjoinusReducer(state: IToppagesjoinusState = initialToppagesjoinusState, action: ToppagesjoinusAction) {
  return produce(state, (draft) => {
    switch (action.type) {
      case ToppagesjoinusActionTypes.SEARCH_TOPPAGESJOINUS:
        draft.searchString = action.searchOptions.searchString
        break
      case ToppagesjoinusActionTypes.SEARCHING_TOPPAGESJOINUS:
        draft.searchingStatus = ApiStatus.LOADING
        draft.loadingStatus = ApiStatus.NOTLOADED
        draft.addingStatus = ApiStatus.NOTLOADED
        break

      case ToppagesjoinusActionTypes.SEARCHING_TOPPAGESJOINUS_FAILED:
        draft.searchingStatus = ApiStatus.FAILED
        break

      case ToppagesjoinusActionTypes.FOUND_TOPPAGESJOINUS:
        draft.searchingStatus = ApiStatus.LOADED
        action.keep
          ? draft.foundtoppagesjoinus.push(...action.payload.toppagesjoinus.docs)
          : (draft.foundtoppagesjoinus = action.payload.toppagesjoinus.docs)
        draft.totalDocs = action.payload.toppagesjoinus.totalDocs
        break

      case ToppagesjoinusActionTypes.LOAD_TOPPAGESJOINUS:
      case ToppagesjoinusActionTypes.LOADING_TOPPAGESJOINUS:
        draft.loadingStatus = ApiStatus.LOADING
        draft.addingStatus = ApiStatus.NOTLOADED
        draft.searchingStatus = ApiStatus.NOTLOADED
        draft.foundtoppagesjoinus = []
        break

      case ToppagesjoinusActionTypes.LOADING_TOPPAGESJOINUS_FAILED:
        draft.loadingStatus = ApiStatus.FAILED
        break

      case ToppagesjoinusActionTypes.LOADED_TOPPAGESJOINUS:
        draft.loadingStatus = ApiStatus.LOADED
        draft.toppagesjoinus = action.payload.toppagesjoinus.docs
        draft.totalDocs = action.payload.toppagesjoinus.totalDocs
        break

      case ToppagesjoinusActionTypes.ADD_TOPPAGESJOINUS:
      case ToppagesjoinusActionTypes.ADDING_TOPPAGESJOINUS:
        draft.addingStatus = ApiStatus.LOADING
        draft.searchingStatus = ApiStatus.NOTLOADED
        draft.errMessage = ''
        draft.errStatus = null
        draft.errField = null
        break

      case ToppagesjoinusActionTypes.ADDING_TOPPAGESJOINUS_FAILED:
        draft.addingStatus = ApiStatus.FAILED
        draft.errMessage = action.message
        draft.errStatus = action.status
        draft.errField = action.field
        break

      case ToppagesjoinusActionTypes.ADDED_TOPPAGESJOINUS:
        draft.addingStatus = ApiStatus.LOADED
        draft.errStatus = 200
        draft.toppagesjoinus.push(action.payload.toppagesjoinus.docs[0])
        if (draft.searchString) draft.foundtoppagesjoinus.push(action.payload.toppagesjoinus.docs[0])
        break

      case ToppagesjoinusActionTypes.REMOVE_TOPPAGEJOINUS:
        draft.toppagesjoinus.splice(
          draft.toppagesjoinus.findIndex((toppagejoinus) => toppagejoinus._id === action.payload._id),
          1
        )
        break

      case ToppagesjoinusActionTypes.SOFT_REMOVE_TOPPAGESJOINUS:
        draft.loadingStatus = ApiStatus.NOTLOADED
        draft.addingStatus = ApiStatus.LOADING
        break

      case ToppagesjoinusActionTypes.SOFT_REMOVING_TOPPAGESJOINUS:
        draft.loadingStatus = ApiStatus.LOADING
        draft.addingStatus = ApiStatus.LOADING
        break

      case ToppagesjoinusActionTypes.SOFT_REMOVED_TOPPAGESJOINUS:
        draft.addingStatus = ApiStatus.LOADED
        draft.toppagesjoinus.splice(
          draft.toppagesjoinus.findIndex((toppagejoinus) => toppagejoinus._id === action.payload._id),
          1
        )
        break

      case ToppagesjoinusActionTypes.SOFT_REMOVING_TOPPAGESJOINUS_FAILED:
        draft.addingStatus = ApiStatus.FAILED
        draft.errMessage = action.message
        draft.errStatus = action.status
        draft.errField = action.field
        break

      case ToppagesjoinusActionTypes.EDIT_TOPPAGESJOINUS:
        draft.loadingStatus = ApiStatus.NOTLOADED
        draft.addingStatus = ApiStatus.LOADING
        draft.searchingStatus = ApiStatus.NOTLOADED
        break

      case ToppagesjoinusActionTypes.EDITING_TOPPAGESJOINUS:
        draft.loadingStatus = ApiStatus.LOADING
        draft.addingStatus = ApiStatus.LOADING
        break

      case ToppagesjoinusActionTypes.EDITED_TOPPAGESJOINUS:
        draft.addingStatus = ApiStatus.LOADED
        draft.toppagesjoinus[draft.toppagesjoinus.findIndex((toppagejoinus) => toppagejoinus._id === action.payload._id)] = action.payload
        draft.foundtoppagesjoinus[draft.foundtoppagesjoinus.findIndex((toppagejoinus) => toppagejoinus._id === action.payload._id)] = action.payload
        break

      case ToppagesjoinusActionTypes.EDITING_TOPPAGESJOINUS_FAILED:
        draft.addingStatus = ApiStatus.FAILED
        draft.errMessage = action.message
        draft.errStatus = action.status
        draft.errField = action.field
        break
    }
  })
}

export interface IToppagesjoinusState {
  loadingStatus: ApiStatus
  addingStatus: ApiStatus
  searchingStatus: ApiStatus
  searchString: string
  toppagesjoinus: IToppagesjoinusItem[]
  foundtoppagesjoinus: IToppagesjoinusItem[]
  totalDocs: number
  errMessage?: string
  errStatus?: number
  errField?: string
}
